import { accessoriesTypes as builtIn } from 'vuejs-avataaars/src/assetsTypes/accessories';

export const accessoriesTypes = {
	...builtIn
}